import { supabase } from '../lib/supabase';

// Statistics must include the entire history, not just Supabase's first page.
export const fetchGroupTransactions = async (groupId) => {
  if (!groupId) return [];
  const transactions = [];
  for (let offset = 0; ; offset += 500) {
    const { data, error } = await supabase.from('transactions').select('*')
      .eq('group_id', groupId).order('id').range(offset, offset + 499);
    if (error) throw error;
    transactions.push(...(data || []));
    if (!data || data.length < 500) return transactions;
  }
};

export const fetchTransactions = async () => {
  try {
    const { data, error } = await supabase
      .from('transactions')
      .select('*')
      .order('timestamp', { ascending: false });

    if (error) {
      console.error('Error fetching transactions:', error);
      return [];
    }

    return data;
  } catch (err) {
    console.error('Unexpected error loading transactions:', err);
    return [];
  }
};
